import { createSelector } from 'reselect';
import get from 'lodash.get';
import createCachedSelector from 're-reselect';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectSavedFilterViews = (state) => get(state, 'savedFilterViews', emptyArray);
export const selectCustomFilterView = (state) => get(state, 'customFilterView');
export const selectDefaultFilterView = (state) => get(state, 'defaultFilterView');
export const selectActiveFilterViewId = (state) => get(state, 'activeFilterViewId');

export const selectActiveFilterView = createSelector(
  selectActiveFilterViewId,
  selectDefaultFilterView,
  selectCustomFilterView,
  selectSavedFilterViews,
  (activeFilterViewId, defaultFilterView, customFilterView, savedFilterViews) => {
    const allViews = [...savedFilterViews, defaultFilterView];

    if (customFilterView) {
      allViews.push(customFilterView);
    }

    return allViews.filter((view) => !!view).find((view) => view.filterViewId === activeFilterViewId);
  },
);

const selectActiveFilterViewFilters = (state) => {
  const activeView = selectActiveFilterView(state);

  if (!activeView) {
    return emptyArray;
  }

  return activeView.appliedFilters || emptyArray;
};

const selectFiltersById = createCachedSelector(
  (filters) => filters,
  (_, filterById) => filterById,
  (filters, filterById) => {
    const activeFilterViewFilters = filters.filter((filter) => filter.filterById === filterById);

    if (activeFilterViewFilters.length === 0) {
      return emptyArray;
    }

    return activeFilterViewFilters;
  },
)((_, filterById) => filterById);

export const selectActiveFilterViewFiltersById = (state, props) => {
  const activeFilters = selectActiveFilterViewFilters(state);

  return selectFiltersById(activeFilters, props.filterById);
};
